module.exports = __webpack_public_path__ + "img/1-low.afdf2f99.jpg";